export const GET_CONTENT_EDITOR_TABLE = "GET_CONTENT_EDITOR_TABLE"
export const GET_CONTENT_EDITOR_TABLE_SUCCESS = "GET_CONTENT_EDITOR_TABLE_SUCCESS"
export const GET_CONTENT_EDITOR_TABLE_FAIL = "GET_CONTENT_EDITOR_TABLE_FAIL"
export const UPDATE_CONTENT_EDITOR_STATE = "UPDATE_CONTENT_EDITOR_STATE"
export const CLEAR_CONTENT_EDITOR_TABLE = "CLEAR_CONTENT_EDITOR_TABLE"
